<div class="panel">
  <header class="panel-header">
    <h1 class="heading" i18n="@@popup.referenceEdit.title">Referenz</h1>
    <button (click)="cancel()" class="cancel" i18n="@@popup.btn.cancel">Abbrechen</button>
  </header>
  <div class="panel-content">
    <form (ngSubmit)="save()" [formGroup]="referenceForm" class="form">
      @if ((isLoading$ | async) === false) {
        <div class="form-group">
          <label class="label" for="reference-comment" i18n="@@popup.referenceEdit.textarea">Referenztext (max 160
                    Zeichen)</label>
          <textarea [formControl]="comment" class="textarea"
            i18n-placeholder="@@popup.referenceEdit.textareaPlaceholder"
            id="reference-comment"
          maxlength="160" placeholder="Ihre Beschreibung über {{ member.firstName }}..."></textarea>
          @if (comment.invalid && comment.touched) {
            <div class="validation error"
              i18n="@@popup.referenceEdit.invalidText">
                    Bitte geben Sie einen Referenztext ein.
                </div>
          }
        </div>
      }
      <app-spinner [visible]="isLoading$ | async" class="loading"></app-spinner>
      <div class="form-group actions">
        <button [disabled]="isLoading$ | async" class="button primary" i18n="@@popup.btn.save" type="submit">
                    Speichern
                </button>
      </div>
    </form>
  </div>
</div>
